import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Plus = (props) => (
  <Icon viewBox="0 0 445 445" {...props}>
    <g>
      <path fill="currentColor" d="M427.4 199.7H245.3V17.6h-45.6v182.1H17.6v45.6h182.1v182.1h45.6V245.3h182.1z" fillRule="evenodd" clipRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Plus;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Plus.js